var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4332 0.0986985C15.7797 0.265218 16 0.615597 16 1V5C18.3482 5 20 7.1649 20 9.5C20 11.8351 18.3482 14 16 14V18C16 18.3844 15.7797 18.7348 15.4332 18.9013C15.0867 19.0678 14.6755 19.021 14.3753 18.7809L9.64922 15H9V21C9 21.5523 8.55228 22 8 22H3C2.44772 22 2 21.5523 2 21V15H1C0.447715 15 0 14.5523 0 14V5C0 4.44772 0.447715 4 1 4H9.64922L14.3753 0.219133C14.6755 -0.0210031 15.0867 -0.0678214 15.4332 0.0986985ZM16 12C16.9655 12 18 11.0309 18 9.5C18 7.96912 16.9655 7 16 7V12ZM4 15H7V20H4V15ZM14 3.08063L10.6247 5.78087C10.4474 5.92272 10.2271 6 10 6H2V13H10C10.2271 13 10.4474 13.0773 10.6247 13.2191L14 15.9194V3.08063Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignIcon);
export default __webpack_public_path__ + "static/media/campaignIcon.c9f247deaebbf31a08a967c50744e34e.svg";
export { ForwardRef as ReactComponent };